export default {
  ALL_SPECIALTIES: 'allSpecialties',
  EMPTY: 'empty',
  PROVIDER: 'provider',
  SPECIALTY: 'specialty'
};
